import React from 'react';
import './styles.css';
export var Section = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.bgColor, bgColor = _b === void 0 ? '#FFFFFF' : _b;
    return (React.createElement("section", { className: 'section', style: { backgroundColor: "" + bgColor } },
        React.createElement("h2", null, title),
        children));
};
